export default __webpack_public_path__ + "4cee8c8d3b273d1bab124755000f4ae1.png";